import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextFillingsFormComponent } from './text-fillings-form.comonent/text-fillings-form/text-fillings-form.component';
import { FillingsFormComponent } from './fillings-form.component/fillings-form/fillings-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ReductionTextFormComponent } from './reduction-text-form.component/reduction-text-form.component';
import { ReductionFillingsFormComponent } from './reduction-fillings-form.component/reduction-fillings-form.component';



@NgModule({
  declarations: [
    TextFillingsFormComponent,
    FillingsFormComponent,
    ReductionTextFormComponent,
    ReductionFillingsFormComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    AngularEditorModule
  ],
  exports:[
    TextFillingsFormComponent,
    FillingsFormComponent,
        ReductionTextFormComponent,
    ReductionFillingsFormComponent
  ]
})
export class TextFillingsFormModule { }
